import { Util,Request } from "@xt/xtbase";
const { XtAxios } = Request;

const { getOrigin } = Util;

const URL = getOrigin("www") + "/acapi";

// 我的福利
export function getUserCoupon(config) {
  return XtAxios.get(`${URL}/welfare/user-coupon`, config);
}

// 我的任务
// export function getUserTask(params) {
//   return XtAxios.get(`${URL}welfar/user-task`, params);
// }

// 卡券任务
export function getCouponTask(config) {
  return XtAxios.get(`${URL}/welfare/coupon-task/${config}`)
}

// 用户任务列表
export function getTaskUserList(config) {
  return XtAxios.get(`${URL}/task/user/list`, config)
}

// 用户任务进度
export function getUserTask(config) {
  return XtAxios.get(`${URL}/task/user/task`, config)
}

// 卡券总数
export function getUsercouponCount() {
  return XtAxios.get(`${URL}/welfare/user-coupon/count`)
}
